export const PROFILE_VOLUNTEER_ERROR = 'PROFILE_VOLUNTEER_ERROR';
export const PROFILE_VOLUNTEER_LOADING = 'PROFILE_VOLUNTEER_LOADING';
export const PROFILE_VOLUNTEER_SUCCESS = 'PROFILE_VOLUNTEER_SUCCESS';